import Table from 'components/Common/StyledTable';
import routes from 'constants/routes';
import { useNavigate } from 'react-router-dom';
import { Parish } from 'types/parishes';

const columns = [
    { id: 'name', label: 'Name' },
    { id: 'archdiocese', label: 'Archdiocese' },
    { id: 'location', label: 'Location' },
];

function AtlantaParishes({ data, loading, totalCount }: { data: Parish[]; loading: boolean; totalCount: number }) {
    const navigate = useNavigate();

    const navigationHandler = (row: Parish) => {
        const id = row.id || row.companyId;
        navigate(routes.parishes.organizationDetails.replace(':companyId', String(id)));
    };

    return (
        <div>
            <Table
                unStyled
                data={data}
                columns={columns}
                totalCount={totalCount}
                serverSidePagination
                navigationHandler={navigationHandler}
                loading={loading}
            />
        </div>
    );
}

export default AtlantaParishes;
